module.exports = __webpack_public_path__ + "assets/img/block-right-78085409.png";